﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDashboard = void 0;
const com = require("../com/tmpls");
const StatePaged_1 = require("./abstracts/StatePaged");
const VXControlView_1 = require("../com/contractViews/VXControlView");
const AppVX_1 = require("../AppVX");
class StateDashboard extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDashboard, "ValidatorX DApp", true);
        this._tiles = [];
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = 'images/favicon_open.svg';
            this.gui.showPage(this.page);
            const calc = new VXControlView_1.VXControlView();
            yield calc.refreshAsync();
            this.page.ctrls.blocks.append(calc);
            calc.ctrls.blockTiles.append(this._addTile("Step 1", "Connect wallet, input PLS stake amount, confirm transaction", "To stake Pulse click 'Connect wallet' button, use slider or input field to enter exact PLS staking amount, click 'Stake PLS' button and sign the transaction"));
            calc.ctrls.blockTiles.append(this._addTile("Step 2", "After cooldown is over use 'Withdraw uPLS' button to get liquid staking token", "Withdaw uPLS tokens after a 2 day cooldown period. uPLS is the liquid staking token that empowers you to remain liquid while staking your PLS"));
            calc.ctrls.blockTiles.append(this._addTile("Step 3", "Add 'uPLS to Wallet' to see uPLS in the wallet", "To add uPLS to your wallet click 'Add uPLS to Wallet'. You can also add uPLS manually, see contract address and more by clicking '+'"));
            this._tilesAnimAsync();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
        });
    }
    _addTile(header, text, desc) {
        let tile = new com.CmpInfoTile();
        tile.ctrls.lHeader.text = header;
        tile.ctrls.lText.text = text;
        tile.ctrls.lDescription.text = desc;
        tile.onclick = () => {
            tile.ctrls.lText.flipClass('hidden');
            tile.ctrls.lDescription.flipClass('hidden');
        };
        this._tiles.push(tile);
        return tile;
    }
    _tilesAnimAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let i = 0;
            let tile = null;
            let tileSwapFunc = () => {
                if (!tile)
                    return;
                tile.ctrls.lText.flipClass('hidden');
                tile.ctrls.lDescription.flipClass('hidden');
            };
            while (true) {
                yield AppVX_1.AppVX.Inst.awaitTime(7000);
                if (tile) {
                    tile.ctrls.lText.removeClass('hidden');
                    tile.ctrls.lDescription.addClass('hidden');
                }
                tile = this._tiles[i];
                if (tile) {
                    tile.ctrls.lText.addClass('hidden');
                    tile.ctrls.lDescription.removeClass('hidden');
                }
                i++;
                if (this._tiles.length <= i)
                    i = 0;
            }
        });
    }
}
exports.StateDashboard = StateDashboard;
StateDashboard.StateName = "dashboard";
//# sourceMappingURL=StateDashboard.js.map